import React from "react";
import { Input, Paper } from "@material-ui/core";
import "./SearchBarMobile.css";
import SearchIcon from "../../../resources/wrappers/SearchIcon";
import { ISearchBarState } from "../ISearchBarState";
import { Route } from "react-router-dom";

export class SearchBarMobile extends React.Component<any, ISearchBarState> {
  inputRef = undefined;
  values: any;
  history = undefined;

  constructor(props: any) {
    super(props);
    this.state = {
      inputValue: "",
      inputFocused: false,
    };
    this.values = this.props.values;
  }

  render() {
    return (
      <Paper id={"search-bar-root"}>
        <div className={"search-bar-input-container"}>
          <Route
            render={({ history }) => {
              return (
                <Input
                  disableUnderline={true}
                  id={"search-bar-input"}
                  placeholder={this.props.placeholder}
                  fullWidth
                  ref={this.inputRef}
                  onFocus={() => {
                    history.push("search", {
                      values: this.values,
                      type: this.props.type,
                      placeholder: this.props.placeholder,
                      data: this.props.data,
                      mobilePosId: this.props.mobilePosId,
                    });
                  }}
                />
              );
            }}
          />
        </div>
        <div className={this.state.inputValue.length >= 3 ? "search-bar-icon-container icon-hidden" : "search-bar-icon-container"}>
          <SearchIcon width={"24px"} height={"24px"} focused={false} />
        </div>
      </Paper>
    );
  }
}
